import { Card, Typography } from 'antd';
import React from 'react';

const { Title, Text } = Typography;

interface BdePipelineCardProps {
    stage: string;
    count: number;
    color: string;
    backgroundColor: string;
}

const BdePipelineCard: React.FC<BdePipelineCardProps> = ({ stage, count, color, backgroundColor }) => (
    <div style={{ textAlign: 'center' }}>
        <Text strong>{stage}</Text>
        <Card
            size="small"
            style={{
                marginTop: 8,
                backgroundColor: backgroundColor,
                borderRadius: 4,
                border: 'none',
                padding: '0 5px'
            }}
            bodyStyle={{ padding: '8px 0', textAlign: 'center' }}
        >
            <Title level={5} style={{ color: color, margin: 0 }}>
                {count} Leads
            </Title>
        </Card>
    </div>
);

export default BdePipelineCard;